import { Tag } from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC } from 'react';

import { type EventCategoryTagsCategoryFragment } from './__generated-gql-types__/EventCategoryTags.generated';
import {
  EventCategoryChangeEvent,
  getEventUrl,
  useChangeCategory,
} from './utils';

interface EventCategoryTagsProps {
  hideTags?: boolean;
  categories?: EventCategoryTagsCategoryFragment[];
}

export const EventCategoryTags: FC<EventCategoryTagsProps> = ({
  hideTags,
  categories,
}) => {
  const onChange = useChangeCategory({ handleNavigation: false });

  if (hideTags || !categories) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-base text-leland-gray-light sm:text-lg">
        Popular categories
      </span>
      <>
        {categories.map((category) => (
          <Link
            href={getEventUrl(category)}
            key={category.id}
            onClick={() => onChange(category, EventCategoryChangeEvent.Tags)}
          >
            <Tag text={category.name} hoverable />
          </Link>
        ))}
      </>
    </div>
  );
};
